var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","margin-top":"16px"}},_vm._l((_vm.optionsList),function(item,index){return _c('div',{key:index,staticClass:"option-item",class:{
    isActive: _vm.selectData.includes(item.title) && !_vm.readonly,
    isTrue:
      _vm.answer.answerResults &&
      _vm.answer.answerResults.includes(item.title) &&
      _vm.answer.answerSituation === '1' &&
      _vm.readonly,
    isFalse:
      _vm.answer.answerResults &&
      _vm.answer.answerResults.includes(item.title) &&
      _vm.answer.answerSituation === '0' &&
      _vm.readonly,
  },on:{"click":function($event){$event.stopPropagation();return _vm.select(item.title, $event)}}},[(_vm.styleType == 1)?_c('div',{staticClass:"questionSeq"},[(_vm.isAnswer &&
        _vm.selectData.length &&
        _vm.selectData.includes(item.title) &&
        _vm.standardAnswer.some((i) => i.title === item.title)
      )?_c('img',{staticStyle:{"margin-right":"10px"},attrs:{"src":require("../../../assets/images/new-right.png"),"alt":""}}):_vm._e(),(_vm.isAnswer &&
        _vm.selectData.length &&
        _vm.selectData.includes(item.title) &&
        _vm.standardAnswer.every((i) => i.title !== item.title)
      )?_c('img',{staticStyle:{"margin-right":"10px"},attrs:{"src":require("../../../assets/images/new-error.png"),"alt":""}}):_vm._e(),(!_vm.readonly && !_vm.isAnswer)?_c('el-checkbox',{attrs:{"value":_vm.selectData.includes(item.title)},nativeOn:{"click":function($event){_vm.SkipProgress($event, item.title, _vm.selectData.includes(item.title))}}},[_vm._v(_vm._s(""))]):_vm._e()],1):_vm._e(),(_vm.showTitle)?_c('div',{staticClass:"questionSeq",staticStyle:{"text-align":"right"}},[_vm._v(" "+_vm._s(_vm.serialNumber[index])+" ")]):_vm._e(),_c('bc-view-common',{attrs:{"flex-box":"1","border":false,"content":item.content,"fileInfo":item.fileInfo}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }